<mat-paginator
  [showFirstLastButtons]="true"
  [length]="paginatorService.paginatorConfig.length"
  [pageSize]="paginatorService.paginatorConfig.pageSize"
  [pageSizeOptions]="paginatorService.paginatorConfig.pageSizeOptions"
  [pageIndex]="paginatorService.paginatorConfig.pageIndex"
  (page)="setPagination($event)"
></mat-paginator>